import { httpClient } from 'app/api/http/http-client';
import { useMutation, useQuery } from 'react-query';

const refreshToken = localStorage.getItem('refreshToken');

const cardService = {
  getCardData: async () => {
    try {
      const result = await httpClient.post<any>('/api-web/v1/main/card_list');

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'accounts-card?type=cards';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },

  changeSmsNotif: async (data: any) => {
    try {
      const result = await httpClient.post<any>('/api-web/v1/main/change_card_sms_notification', data.data);

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'accounts-card?type=cards';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },

  changeCardStatus: async (data: any) => {
    try {
      const result = await httpClient.post<any>('/api-web/v1/main/change_card_status', data.data);

      return result;
    } catch (err: any) {
      if (err?.response.status === 400) {
        return err?.response.data;
      }

      if (err?.response?.status === 401) {
        window.location.href = 'login';
        localStorage.clear();
      }
      if (err?.response?.status === 403 || err?.code === 'ERR_NETWORK') {
        try {
          const result = await httpClient.post<any>(`/api-web/v1/pub/refresh_token?refresh_token=${refreshToken}`);
          // refetchGetHeaderAndMenu();

          localStorage.setItem('refreshToken', result.refresh_token);

          window.location.href = 'accounts-card?type=cards';
        } catch (errRefresh: any) {
          if (errRefresh?.response.status === 401) {
            window.location.href = 'login';
            localStorage.clear();
          }
        }
      }
    }
  },
};

export const useGetCard = (dataTransfer?: any) => {
  const {
    isFetching: isFetchingGetDataCard,
    isLoading: isLoadingGetDataCard,
    data: dataGetCard,
    refetch: refetchGetDataCard,
  } = useQuery(['getCardData'], cardService.getCardData, {
    cacheTime: 0,
    enabled: false,
  });

  return { isFetchingGetDataCard, isLoadingGetDataCard, dataGetCard, refetchGetDataCard };
};

export const useChangeSmsNotif = () => {
  const { isLoadingGetDataCard, refetchGetDataCard, dataGetCard } = useGetCard();
  const {
    isLoading: isLoadingSmsNotif,
    data: dataSmsNotif,
    mutate: smsNotifMutation,
  } = useMutation(['changeSmsNotif'], (data: { data: any }) => cardService.changeSmsNotif(data), {
    onSuccess: () => {
      refetchGetDataCard();
    },
  });

  return {
    isLoadingSmsNotif,
    smsNotifMutation,
    dataSmsNotif,
  };
};

export const useChangeCardStatus = () => {
  const { isLoadingGetDataCard, refetchGetDataCard, dataGetCard } = useGetCard();
  const {
    isLoading: isLoadingCardStatus,
    data: dataCardStatus,
    mutate: cardStatusMutation,
  } = useMutation(['changeSmsNotif'], (data: { data: any }) => cardService.changeCardStatus(data), {
    onSuccess: () => {
      refetchGetDataCard();
    },
  });

  return {
    isLoadingCardStatus,
    cardStatusMutation,
    dataCardStatus,
  };
};
